import React from "react";
import { Box } from "@mui/material";

// Small uppercase eyebrow badge used across the dark public-site sections.
const DarkPill = ({ children, sx }) => (
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: 1,
      fontSize: 12,
      fontWeight: 600,
      letterSpacing: ".08em",
      textTransform: "uppercase",
      px: 2,
      py: 0.875,
      borderRadius: "100px",
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default DarkPill;
